import type { WalletAccount } from '@dynamic-labs-sdk/client';

import { ZERODEV_METADATA } from '../constants';

/**
 * Type guard function to check if a wallet account is a Zerodev wallet account.
 *
 * @param walletAccount - The wallet account to check.
 * @returns True if the wallet account is a Zerodev wallet account, false otherwise.
 */
export const isZerodevWalletAccount = (
  walletAccount: WalletAccount
): boolean => {
  return walletAccount.walletProviderKey.startsWith(
    ZERODEV_METADATA.normalizedWalletName
  );
};
